// Die System-Einstellungen als Store (docs/einstellungen-inventar.md).
//
// Quelle: GET /v2-api/settings/global -- ein Schnappschuss aller
// bekannten Schluessel. Geschrieben wird per PATCH mit NUR dem
// geaenderten Feld; das Backend laesst fehlende Felder unangetastet.
//
// Warum ein Store und kein fetch in der Seite: das Einstellungsfenster
// ist nicht der einzige Leser (die Allgemein-Seite gibt es weiter,
// solange sie nicht abgeloest ist), und zwei Leser mit zwei eigenen
// Ladepfaden laufen garantiert auseinander (docs/data-loading.md).
//
// Optimistisch schreiben: der Wert steht sofort, der PATCH laeuft
// hinterher. Scheitert er, holen wir den Server-Stand zurueck -- die
// Oberflaeche darf nicht behaupten, etwas sei gespeichert, was es nicht
// ist.

import { getJSON, patchJSON } from "../api";

export interface SystemWerte {
  timezone: string;
  log_retention_days: number;
  climate_history_retention_days: number;
  local_api_access: boolean;
  dns_primary: string;
  network_openwrt_alias: string;
  home_latitude: number;
  home_longitude: number;
  electricity_price_eur: number;
  netzfrequenz_warn_mhz: number;
  netzfrequenz_crit_mhz: number;
  netzfrequenz_hold_s: number;
  front_door_sensor: string;
  front_door_open_min: number;
  /** Netze, in denen eine vom Host-Agenten gemeldete Adresse für SSH gilt. */
  ssh_netze: string[];
  /** Claude: was vom Wochenlimit am letzten Tag der Woche frei bleibt, % */
  claude_reserve_prozent: number;
}

let werte = $state<SystemWerte | null>(null);
let fehler = $state<string>("");
let gestartet = false;

export function getSystemWerte(): SystemWerte | null {
  return werte;
}
export function getSystemFehler(): string {
  return fehler;
}

async function hole(): Promise<void> {
  try {
    werte = await getJSON<SystemWerte>("/v2-api/settings/global");
    fehler = "";
  } catch (e) {
    fehler = e instanceof Error ? e.message : String(e);
  }
}

/** startSystemWerte laedt den Schnappschuss einmal. Idempotent.
 *  Kein Polling: diese Werte aendert nur, wer sie hier aendert. */
export function startSystemWerte(): void {
  if (gestartet) return;
  gestartet = true;
  void hole();
}

/** setzeSystemWert schreibt genau EIN Feld. */
export async function setzeSystemWert<K extends keyof SystemWerte>(
  schluessel: K,
  wert: SystemWerte[K],
): Promise<void> {
  if (!werte) return;
  const vorher = werte[schluessel];
  werte = { ...werte, [schluessel]: wert };
  try {
    // Die ANTWORT uebernehmen, nicht den gesendeten Wert: das Backend
    // klemmt (Strompreis auf 0-10, Aufbewahrung auf >=1) und normiert
    // Text. Wer den gesendeten Wert stehen laesst, zeigt eine Zahl an,
    // die so nirgends gespeichert ist -- gemessen am 15.08.: getippte
    // 420,3 blieben im Feld stehen, in der DB standen 10.
    werte = await patchJSON<SystemWerte>("/v2-api/settings/global", {
      [schluessel]: wert,
    });
    fehler = "";
  } catch (e) {
    // Zurueckdrehen und den Server fragen -- er hat recht, nicht wir.
    werte = { ...werte, [schluessel]: vorher };
    fehler = e instanceof Error ? e.message : String(e);
    void hole();
    throw e;
  }
}
